import { Route } from 'vue-router';
import { RouterBehavior } from '@/models';

const { SMOOTH } = RouterBehavior;

export const scrollBehavior = (to: Route) => (to.hash
  ? { selector: to.hash, offset: undefined, behavior: SMOOTH }
  : { x: 0, y: 0 });
